import NumberPicker from '~/src/common/components/NumberPicker/NumberPicker';
import I18n from '~/src/common/services/I18n/I18n';
import { useGetCart } from '~/src/queries/api-ecom/generated/api-ecom';
import { MAXIMUM_RECIPE_SERVINGS } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/constants';
import { useRecipeScreenAnalyticsContext } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/context';
import { ChangeServingsAnalyticsInfo } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/hooks/useServings';
import {
  ClientRecipeIngredientProduct,
  Recipe,
} from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/types';
import getAvailableArticlesFromIngredients from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/utils/getAvailableArticlesFromIngredients';

import * as S from './layout';

interface Props {
  className?: string;
  ingredients: ClientRecipeIngredientProduct[];
  isAdding: boolean;
  recipe: Recipe;
  servings: number;
  onAddAllArticles: (source: 'ingredients list' | 'principal ATC') => Promise<void>;
  onChangeServings: (servings: number, info: ChangeServingsAnalyticsInfo) => void;
}

export const RecipeAddToCart = (props: Props) => {
  const { categoryName, subcategoryName } = useRecipeScreenAnalyticsContext();

  const handleServingsChange = (value: number) => {
    props.onChangeServings(value, {
      recipe: props.recipe,
      categoryName,
      subcategoryName,
      location: 'near CTA',
    });
  };

  const handleAddAllArticles = () => {
    void props.onAddAllArticles('principal ATC');
  };

  const { data: cart } = useGetCart();

  const isButtonEnabled = getAvailableArticlesFromIngredients(
    props.ingredients,
    cart?.products ?? [],
  ).some(i => {
    const cartQuantity = cart?.products?.find(p => p.id === i.id)?.quotation2.count.quantity ?? 0;

    return i.availableQuantity - cartQuantity >= i.packSize;
  });

  return (
    <S.Root className={props.className}>
      <NumberPicker
        value={props.servings}
        minimumValue={1}
        maximumValue={MAXIMUM_RECIPE_SERVINGS}
        maximumValueReachedText={I18n.t('recipe-screen.max-portions-reached')}
        onChange={handleServingsChange}>
        {({ value }) => (
          <S.PortionsText>
            <span>{value}</span>
            <span>{I18n.t('recipe-screen.portion-picker', { count: value })}</span>
          </S.PortionsText>
        )}
      </NumberPicker>

      <S.AddToCartButton
        disabled={!isButtonEnabled}
        onClick={handleAddAllArticles}
        icon="basket-normal"
        loading={props.isAdding}>
        {I18n.t('common.add-to-cart-with-icon')}
      </S.AddToCartButton>
    </S.Root>
  );
};
